import { RolApp } from '../types/auth'

/*
  Los roles de la app (docs/ROLES.md): cómo se llaman y qué permiten. La administración
  de la app (usuarios, integraciones) no es un rol: es `es_staff`.
*/

export const ROLES: Record<RolApp, { texto: string; detalle: string }> = {
  administra_bienes: { texto: 'Administra bienes', detalle: 'Todo el inventario, y aprueba o rechaza los traslados pedidos.' },
  solicita_traslados: { texto: 'Solicita traslados', detalle: 'Ve el inventario y pide que se trasladen bienes.' },
}

export const TODOS_LOS_ROLES = Object.keys(ROLES) as RolApp[]

/** Quienes ven el inventario: lo administran o piden traslados (solo lectura). */
export const VEN_INVENTARIO: RolApp[] = ['administra_bienes', 'solicita_traslados']
